import * as Yup from 'yup';

export const templateSchema = Yup.object().shape({
    id: Yup.string().required('ID is required'),
    name: Yup.string().required('Name is required'),
});
